<template>
  <datepicker :value="value" :format="customFormatter" v-on:selected="updatedDate($event)"></datepicker>
</template>

<script>
// import _ from 'lodash'
import Vue from 'vue'
import DatePicker from 'vuejs-datepicker'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
Vue.use(VueMomentJS, moment)

export default {
  props: {
    value: undefined,
    index: undefined,
    date_format: {
      default: 'YYYY-MM-DD'
    }
  },
  components: {
    'datepicker': DatePicker
  },
  methods: {
    updatedDate: function (date) {
      let index = this.index
      let payload = {index: index, date: date}
      var self = this
      self.$emit('updated', payload)
    },
    customFormatter: function (date) {
      return this.$moment(date).format(this.date_format)
    }
  }
}
</script>



// WEBPACK FOOTER //
// gl-datepicker.vue?6177c05d